<template>
    <div class="roller-cards__block">
        <div class="roller-cards__card" v-for="card in cards">
            <div class="roller-cards__card_block">
                <img class="roller-cards__card_img" :src="card.img" alt="" />
                <div class="roller-cards__card_desc">
                    <div class="roller-cards__card_title">{{ card.title }}</div>
                    <div class="roller-cards__card_text">
                        {{ card.text }}
                    </div>
                    <div class="roller-cards__card_price">{{ card.price }}</div>
                    <div class="roller-cards__card_listing">
                        <div class="roller-cards__card_list">
                            <img
                                class="roller-cards__card_list_icon"
                                src="/assets/img/roller/confirm-circle.svg"
                                alt=""
                            />
                            <span class="roller-cards__card_list_text">
                                {{ card.list1 }}
                            </span>
                        </div>
                        <div class="roller-cards__card_list">
                            <img
                                class="roller-cards__card_list_icon"
                                src="/assets/img/roller/confirm-circle.svg"
                                alt=""
                            />
                            <span class="roller-cards__card_list_text">
                                {{ card.list2 }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <a class="btn _primary roller-cards__card_link" :href="card.link"
                >Выбрать изделие</a
            >
        </div>
        <div class="roller-cards__card_last">
            <div class="roller-cards__card_last_block">
                <div class="roller-cards__card_last_title">
                    Требуется помощь с подбором идеальных штор в вашем случае?
                </div>
                <div class="roller-cards__card_last_text">
                    Оставьте заявку и наш менеджер сориентирует Вас, это
                    бесплатно.
                </div>
                <div class="roller-cards__card_last_btn">
                    <a
                        class="btn _primary roller-cards__card_last_link"
                        href="#"
                        >Посмотреть ткани</a
                    >
                    <img
                        class="roller-cards__card_last_btn_line"
                        src="/assets/img/roller/button-line.svg"
                        alt="line"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'roller-cards__card',
    data() {
        return {
            cards: [
                {
                    id: 1,
                    img: '/assets/img/roller/card-1.png',
                    title: 'Миникассета',
                    text: 'Рулонная штора в коробе с креплением на створку окна. Идет в комплекте с направляющими, которые не дают полотну изделия провисать.',
                    price: 'от 5 000 ₽',
                    list1: 'Рулон спрятан в короб',
                    list2: 'Плотное прилегание к стеклу',
                    link: '#',
                },
                {
                    id: 2,
                    img: '/assets/img/roller/card-2.png',
                    title: 'Рулонная штора на створку',
                    text: 'Рулонная штора с креплением на створку окна. Идет в комплекте с направляющими, которые не дают полотну изделия провисать.',
                    price: 'от 5 000 ₽',
                    list1: 'Рулон открыт и виден',
                    list2: 'Плотное прилегание к стеклу',
                    link: '#',
                },
                {
                    id: 3,
                    img: '/assets/img/roller/card-3.png',
                    title: 'Рулонная штора Твин',
                    text: 'Оригинальное и практичное решение для широких оконных проемов. Рулонная штора Твин состоит из двух изделий: на окно и балконную дверь.',
                    price: 'от 5 000 ₽',
                    list1: 'Два изделия: на окно и балконую дверь',
                    list2: 'Позволяет закрывать нестандартные проемы шириной до 6 метров',
                    link: '#',
                },
                {
                    id: 4,
                    img: '/assets/img/roller/card-4.png',
                    title: 'Рулонная штора Моно',
                    text: 'Благодаря особой конструкции система позволяет закрывать нестандартные большие (широкие) окна до 7 метров и избежать прогибов вала под тяжестью ткани.',
                    price: 'от 5 000 ₽',
                    list1: 'Состоит из трех изделий',
                    list2: 'Управляется единым механизмом',
                    link: '#',
                },
                {
                    id: 5,
                    img: '/assets/img/roller/card-5.png',
                    title: 'Рулонная штора Комби',
                    text: 'Одна из разновидностей классических рулонных штор. Состоит из двух изделий, устанавливаемых на общие кронштейны.',
                    price: 'от 5 000 ₽',
                    list1: 'Две ткани разной плотности на одном кронштейне',
                    list2: 'Полотна ткани управляются независимо друг от друга',
                    link: '#',
                },
                {
                    id: 6,
                    img: '/assets/img/roller/card-6.png',
                    title: 'Рулонная штора День-Ночь',
                    text: 'Чередование двух видов ткани (плотной и полупрозрачной) дают возможность регулирования попадания солнечного света',
                    price: 'от 5 000 ₽',
                    list1: 'Чередование тканей: прозрачной и полупрозрачной',
                    list2: 'Регулирование интенсивности солнечного света в помещении',
                    link: '#',
                },
                {
                    id: 7,
                    img: '/assets/img/roller/card-7.png',
                    title: 'Рулонная штора День-Ночь на створку',
                    text: 'возможность регулирования попадания солнечного света в комнату, при этом совершенно не занимая пространства подоконника.',
                    price: 'от 5 000 ₽',
                    list1: 'Чередование тканей: прозрачной и полупрозрачной',
                    list2: 'Регулирование интенсивности солнечного света в помещении',
                    link: '#',
                },
            ],
        };
    },
};
</script>
